import { Route, Routes } from "react-router-dom";
import S3DownloadCenter from "./S3DownloadCenter/main";
import S3Issuers from "./S3Issuers/main";
import S3PdfPageSelection from "./S3PdfPageSelection/main";
import S3Portfolios from "./S3Portfolios/main";
import S3StaticData from "./S3StaticData/main";
import S3TimeSeries from "./S3TimeSeries/main";
import S3Transactions from "./S3Transactions/main";
import S3Events from "./S3Events/main";
import S3DataUpload from "./S3DataUpload/main";
import S3BankPositions from "./S3BankPositions/main";
import { Tables } from "@/gen/tableNames/tables";
import { ClientTables } from "@/lib/clientTables";

export default function S3Routes() {
  const routeAliases = {
    downloadCenter: "s3_download_center",
    issuers: "s3_issuers",
    pdfPageSelection: "s3_pdf_page_selection",
    portfolios: "s3_portfolios",
    staticData: "s3_static_data",
    timeSeries: "s3_time_series",
    transactions: "s3_transactions",
    bankPositions: "s3_bank_positions",
    events: "s3_events",
    dataUpload: "s3_data_upload",
  } as const;

  return (
    <Routes>
      <Route
        path={`${ClientTables.S3_DOWNLOAD_CENTER}/*`}
        element={<S3DownloadCenter />}
      />
      <Route
        path={`${routeAliases.downloadCenter}/*`}
        element={<S3DownloadCenter />}
      />
      <Route path={`${Tables.S3_ISSUERS}/*`} element={<S3Issuers />} />
      <Route path={`${routeAliases.issuers}/*`} element={<S3Issuers />} />
      <Route
        path={`${Tables.S3_PDF_PAGE_SELECTION}/*`}
        element={<S3PdfPageSelection />}
      />
      <Route
        path={`${routeAliases.pdfPageSelection}/*`}
        element={<S3PdfPageSelection />}
      />
      <Route path={`${Tables.S3_PORTFOLIOS}/*`} element={<S3Portfolios />} />
      <Route path={`${routeAliases.portfolios}/*`} element={<S3Portfolios />} />
      <Route path={`${Tables.S3_STATIC_DATA}/*`} element={<S3StaticData />} />
      <Route path={`${routeAliases.staticData}/*`} element={<S3StaticData />} />
      <Route path={`${Tables.S3_EVENTS}/*`} element={<S3Events />} />
      <Route path={`${routeAliases.events}/*`} element={<S3Events />} />
      <Route path={`${Tables.S3_TIME_SERIES}/*`} element={<S3TimeSeries />} />
      <Route path={`${routeAliases.timeSeries}/*`} element={<S3TimeSeries />} />
      <Route
        path={`${Tables.S3_TRANSACTIONS}/*`}
        element={<S3Transactions />}
      />
      <Route
        path={`${routeAliases.transactions}/*`}
        element={<S3Transactions />}
      />
      <Route
        path={`${Tables.S3_BANK_POSITIONS}/*`}
        element={<S3BankPositions />}
      />
      <Route
        path={`${routeAliases.bankPositions}/*`}
        element={<S3BankPositions />}
      />
      <Route
        path={`${ClientTables.S3_DATA_UPLOAD}/*`}
        element={<S3DataUpload />}
      />
      <Route path={`${routeAliases.dataUpload}/*`} element={<S3DataUpload />} />
    </Routes>
  );
}
